import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './services/auth';
import { Analytics } from '@vercel/analytics/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './services/auth';
import ExtensionsPage from "./pages/extensionspage"

// Layouts
import ProtectedLayout from './components/Layout/Layout';
import PublicLayout from './components/Layout/PublicLayout';

// Pages
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/DashboardPage';
import Recording from './pages/RecordingPage';
import SettingsPage from './pages/SettingsPage';
import AuthPage from './pages/AuthPage';
import FilesPage from './pages/MyFIlespage';
import CreationPage from './pages/Mycreationspage';
import PricingPage from './pages/pricingPage';
import SuccessRoute from './pages/payment/success';
import TextToSpeech from './pages/ttspage';

// Route Components
const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  return isAuthenticated && user ? <Outlet /> : <Navigate to="/auth" replace />;
};

const PublicRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? <Outlet /> : <Navigate to="/dashboard" replace />;
};

// Routes Configuration
const RouteConfig: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/extensions" element={<ExtensionsPage />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route element={<PublicRoute />}>
          <Route path="/auth" element={<AuthPage />} />
        </Route>
      </Route>

      {/* Payment Success Route */}
      <Route element={<ProtectedRoute />}>
        <Route path="/payment/success" element={<SuccessRoute />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedLayout />}>
        <Route element={<ProtectedRoute />}>
          <Route path="/tts" element={<TextToSpeech />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/recording" element={<Recording />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/myfiles" element={<FilesPage />} />
          <Route path="/creationfiles" element={<CreationPage />} />
        </Route>
      </Route>

      {/* Catch-all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

// App Component
const App: React.FC = () => {
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!GOOGLE_CLIENT_ID) {
    console.error('Google Client ID is not defined in environment variables');
    return null;
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Analytics />
        <RouteConfig />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
